import { render, staticRenderFns } from "./TrailModeCourse.vue?vue&type=template&id=b9c9b2b4&"
import script from "@/scripts/TrailMode/TrailModeCourse/index.js?vue&type=script&lang=js&"
export * from "@/scripts/TrailMode/TrailModeCourse/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports